import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "knowledge-test__risks",
  "aria-labelledby": "knowledge-risk-title"
}
const _hoisted_2 = { id: "knowledge-risk-title" }
const _hoisted_3 = ["checked", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("Подтверждение ознакомления с рисками")), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t(
          "Настоящим подтверждаю, что вопросы мне понятны, ответы выбраны мною самостоятельно. ОсОО «Асикс» уведомило меня о следующих основных рисках и особенностях:"
        )), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.risks, (risk) => {
        return (_openBlock(), _createElementBlock("li", { key: risk }, _toDisplayString(_ctx.$t(risk)), 1))
      }), 128))
    ]),
    _createElementVNode("label", {
      class: _normalizeClass(["knowledge-test__consent", { 'knowledge-test__consent--selected': _ctx.modelValue }])
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        checked: _ctx.modelValue,
        disabled: _ctx.disabled,
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeConsent && _ctx.changeConsent(...args)))
      }, null, 40, _hoisted_3),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(
          "Подтверждаю, что ознакомлен(а) с указанными рисками, понимаю их и принимаю решение о совершении операций самостоятельно."
        )), 1)
    ], 2)
  ]))
}